module.exports = __webpack_public_path__ + "img/1.6b09590c.jpg";